import * as React from 'react';

export interface IRadioFilterItemProps {
    id: string,
    name: string,
    label: string,
    value: any,
    isApplied: boolean,
    onChangeHandler(value: any): void
}

export class RadioFilterItem extends React.Component<IRadioFilterItemProps, {}>{

    render() {
        return (
            <div className="filters-radio-item">
                <input type="radio"
                    id={this.props.id}
                    name={this.props.name}
                    value={this.props.value}
                    checked={this.props.isApplied}
                    onChange={() => this.props.onChangeHandler(this.props.value)} />
                <label htmlFor={this.props.id}>{this.props.label}</label>   
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./~/source-map-loader!./app/src/shared/radio-filter-item.tsx